import {registerTileSchema} from '../../../schema-registry.js';

import SEARCH_RESULT from './search-result.palette-schema.yaml';

registerTileSchema(SEARCH_RESULT);

export function generateRecentSearch(TILE) {
    return {
        itemIcon: {
            style: TILE.SEARCH_RECENT_ITEM_ICON_COLOR ? {fill: TILE.SEARCH_RECENT_ITEM_ICON_COLOR} : {},
        },
        itemText: {
            style: {
                ...TILE.SEARCH_RECENT_ITEM_TEXT,
            },
        },
        removeIcon: {
            style: TILE.SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR ? {fill: TILE.SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR} : {},
        },
    };
}
export function generateSearchResultItem(TILE) {
    const SEARCH_RESULT_ITEM_STATUS_BASE_TEXT = {
        ...TILE.SEARCH_RESULT_ITEM_STATUS_TEXT,
    };
    const SEARCH_RESULT_ITEM_NAME_TEXT_STYLES = {
        ...TILE.SEARCH_RESULT_ITEM_NAME_TEXT,
    };

    return {
        searchNamesContainer: {
            itemSpacing: 0,
        },
        infoContainer: {
            itemSpacing: 2,
        },
        button: {
            style: {
                base: {
                    padding: '8px 16px',
                },
            },
        },
        searchItemIcon: {
            style: {
                fill: TILE.SEARCH_RESULT_ITEM_ICON_COLOR,
                flexBasis: '32px',
                padding: '5px 8px 5px 0',
            },
        },
        parentText: {
            style: {
                ...TILE.SEARCH_RESULT_ITEM_TOURNAMENT_TEXT,
            },
        },
        sportNameText: {
            style: SEARCH_RESULT_ITEM_NAME_TEXT_STYLES,
        },
        nameText: {
            style: SEARCH_RESULT_ITEM_NAME_TEXT_STYLES,
        },
        live: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
        startDate: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
        startTime: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
    };
}
